<script>
export default {
  name: 'AppGalleryItem',
  inject: {
    $appGallery: {
      default: () => ({
        addItem: () => {},
      }),
    },
  },
  props: {
    url: {
      type: String,
      required: true,
    },
    thumbUrl: {
      type: String,
      default: '',
    },
    caption: {
      type: String,
      default: '',
    },
  },
  mounted() {
    this.$appGallery.addItem({
      src: this.url,
      thumb: this.thumbUrl,
      subHtml: this.caption,
    });
  },
  render() {
    return null;
  },
};
</script>
